import Kitsu from 'kitsu';
import mergeOptions from 'merge-options';

const kitsuDefaults = {
  timeout: 60000,
  camelCaseTypes: false,
  pluralize: false,
};

export default function createApi(serviceUrl, serviceOptions = {}) {
  const options = mergeOptions(kitsuDefaults, serviceOptions);
  const kitsu = new Kitsu({
    baseURL: `${process.env.VUE_APP_API_URL}/${serviceUrl}`,
    ...options,
  });
  options.middleware.forEach(x => x(kitsu));
  return kitsu;
}
